import { render, staticRenderFns } from "./CarrinhaEmpresaFinalizarDetalhes.vue?vue&type=template&id=1a849d05"
import script from "./CarrinhaEmpresaFinalizarDetalhes.vue?vue&type=script&lang=js"
export * from "./CarrinhaEmpresaFinalizarDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports